import { Entity, time } from "@dinahmoe/dmafjs-core";

class ControlEventAnd extends Entity {
  namespace = "control:event:and";

  init(node) {
    const eventsEntries = node.props.eventNames.map((name) => [name, false]);
    node.events = Object.fromEntries(eventsEntries);
  }

  execute(node, config, event) {
    // change in v20, untested
    node.props = config;

    if (!node.props.eventNames.includes(event.name)) {
      return;
    }

    node.events[event.name] = event.data;

    const eventsState = Object.values(node.events);
    if (eventsState.every(Boolean)) {
      this.dispatch(node.props.outEvent, time.current, node.events);
    }
  }

  reset(node) {
    Object.keys(node.events).forEach((event) => (node.events[event] = false));
  }
}

const controlEventAnd = new ControlEventAnd();
export { controlEventAnd, ControlEventAnd };
